export const POPUP_TYPE = {
    valueBike: 'Value Bike',
    updateValuation: 'Update Valuation',
    updateValuationTrade: 'Update Valuation (Trade)',
    valueBikeTrade: 'Value Bike (Trade)',
    startBlemishReport: 'Start Blemish Report',
    bookDelivery: 'Book Delivery',
    updatePrice: 'Update Price',
    HPICheck: 'HPI Check',
    redoHPICheck: 'Redo HPI Check',
    cancelCollection: 'Cancel Collection',
    cancelCollectionTrade: 'Cancel Collection (Trade)'
};



// WEBPACK FOOTER //
// ./src/modules/Leads/constants/popupType.js